(function () {
  'use strict';

  var BANNER_ID = 'jj-everyday-savings-bar';
  var PROMO_DEADLINE = Date.parse('2026-10-31T22:59:59Z');
  var dismissed = false;
  var signature = null;
  var banner = null;
  var version = 0;
  var baseFetch = window.fetch ? window.fetch.bind(window) : null;

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      return [item.key || item.id, item.quantity].join(':');
    }).sort().join('|');
  }

  function basePath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function buildBanner() {
    if (banner) return banner;
    var style = document.createElement('style');
    style.id = 'jj-3x2-savings-bar-style';
    style.textContent = [
      '#' + BANNER_ID + '[hidden]{display:none!important}',
      '#' + BANNER_ID + '{position:fixed;z-index:99990;bottom:calc(10px + env(safe-area-inset-bottom,0px));left:50%;transform:translateX(-50%);width:min(520px,calc(100vw - 20px));padding:13px 15px;background:linear-gradient(125deg,#194b35,#276646);color:#fff;border:1px solid rgba(236,255,243,.3);border-radius:16px;box-shadow:0 13px 32px rgba(15,48,32,.28);font-family:Arial,sans-serif;box-sizing:border-box}',
      '#' + BANNER_ID + ' *{box-sizing:border-box}',
      '.jj-promo3-top{display:flex;align-items:center;justify-content:space-between;gap:12px}',
      '.jj-promo3-kicker{font-size:10px;letter-spacing:.09em;font-weight:900;color:#cdf3d8}',
      '.jj-promo3-close{display:grid;place-items:center;width:30px;height:30px;flex:0 0 30px;border:0;border-radius:50%;background:rgba(255,255,255,.13);color:#fff;font-size:22px;line-height:1;cursor:pointer}',
      '.jj-promo3-heading{display:block;margin:3px 0 4px;font-size:19px;line-height:1.17;font-weight:900;color:#fff}',
      '.jj-promo3-detail{margin:0 0 10px;font-size:12px;line-height:1.35;color:#eefbf1}',
      '.jj-promo3-actions{display:flex;align-items:center;gap:12px;margin:8px 0 7px}',
      '.jj-promo3-choose{display:inline-flex;align-items:center;justify-content:center;min-height:39px;min-width:0;padding:9px 15px;background:#fff;color:#155233!important;border-radius:40px;text-decoration:none!important;font-size:12px;font-weight:900;text-align:center}',
      '.jj-promo3-cart{display:inline-flex;align-items:center;justify-content:center;min-height:43px;padding:9px 17px;border:2px solid #f6df9d;border-radius:40px;background:#f6df9d;color:#173d2b!important;text-decoration:none!important;font-size:13px;font-weight:900;white-space:nowrap;box-shadow:0 3px 12px rgba(0,0,0,.16);transition:background .2s,transform .2s}.jj-promo3-cart:hover,.jj-promo3-cart:focus-visible{background:#ffeab4;border-color:#ffeab4;transform:translateY(-1px)}',
      '.jj-promo3-track{height:7px;border-radius:20px;background:rgba(255,255,255,.25);overflow:hidden}',
      '.jj-promo3-progress{height:100%;width:0;background:#bdf4ce;border-radius:20px;transition:width .3s ease}',
      '.jj-promo3-stages{display:flex;justify-content:space-between;margin-top:5px;font-size:10px;font-weight:700;color:#e1f7e8}',
      '.jj-promo3-note{display:block;margin-top:5px;font-size:10px;line-height:1.3;color:#d8f3df}',
      '.jj-promo3-visible{padding-bottom:202px!important}',
      '@media(max-width:480px){#' + BANNER_ID + '{padding:11px 13px;border-radius:14px}.jj-promo3-heading{font-size:17px}.jj-promo3-detail{font-size:11px;margin-bottom:8px}.jj-promo3-choose{flex:1;padding:8px 11px}.jj-promo3-actions{gap:8px}.jj-promo3-cart{padding:8px 12px;font-size:12px;min-height:42px}.jj-promo3-visible{padding-bottom:206px!important}}',
      '@media(prefers-reduced-motion:reduce){.jj-promo3-progress{transition:none}}'
    ].join('');
    document.head.appendChild(style);

    banner = document.createElement('aside');
    banner.id = BANNER_ID;
    banner.setAttribute('aria-label', 'Progreso para conseguir el 3x2 en toda la tienda');
    banner.hidden = true;
    banner.innerHTML =
      '<div class="jj-promo3-top"><span class="jj-promo3-kicker">TODA LA TIENDA · OFERTA 3x2</span><button class="jj-promo3-close" type="button" aria-label="Cerrar aviso">×</button></div>' +
      '<strong class="jj-promo3-heading" aria-live="polite"></strong>' +
      '<p class="jj-promo3-detail"></p>' +
      '<div class="jj-promo3-actions"><a class="jj-promo3-choose" href="/collections/all">Seguir comprando →</a><a class="jj-promo3-cart" href="/checkout">Ir al pago</a></div>' +
      '<div class="jj-promo3-track" role="progressbar" aria-label="Progreso hacia el siguiente 3x2" aria-valuemin="0" aria-valuemax="3" aria-valuenow="0"><div class="jj-promo3-progress"></div></div>' +
      '<div class="jj-promo3-stages"><span>1 artículo</span><span>2 artículos</span><span>3x2 completo</span></div>' +
      '<small class="jj-promo3-note">Combina productos de cualquier categoría. El de menor precio es gratis; cada pack cuenta como un artículo.</small>';
    document.body.appendChild(banner);
    banner.querySelector('.jj-promo3-close').addEventListener('click', function () {
      dismissed = true;
      hide();
    });
    return banner;
  }

  function hide() {
    if (banner) banner.hidden = true;
    if (document.body) document.body.classList.remove('jj-promo3-visible');
  }

  function render(cart) {
    if (Date.now() >= PROMO_DEADLINE) { hide(); return; }
    if (!cart || !Array.isArray(cart.items)) return;
    var nextSignature = cartSignature(cart);
    if (signature !== null && nextSignature !== signature) dismissed = false;
    signature = nextSignature;
    var totalItems = cart.items.reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.quantity) || 0);
    }, 0);
    if (!totalItems || dismissed) {
      hide();
      return;
    }

    var count = cart.items.reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.quantity) || 0);
    }, 0);
    var completeGroups = Math.floor(count / 3);
    var partial = count % 3;
    var heading = '';
    var detail = '';

    if (count === 0) {
      heading = '¡Tu pedido puede tener un 3x2!';
      detail = 'Elige 3 productos de cualquier categoría y paga solo 2: el de menor precio es GRATIS.';
    } else if (count === 1) {
      heading = '¡Solo te faltan 2 para el 3x2!';
      detail = 'Añade dos artículos más y el de menor precio de los 3 será GRATIS.';
    } else if (count === 2) {
      heading = '¡Añade 1 más y activa el 3x2!';
      detail = 'El artículo de menor precio de los 3 te saldrá GRATIS.';
    } else if (partial === 0) {
      heading = completeGroups === 1 ? '¡Ya tienes tu 3x2!' : '¡Ya tienes ' + completeGroups + ' ofertas 3x2!';
      detail = 'El artículo de menor precio de cada grupo sale GRATIS. ¡Añade 3 más y repite la oferta!';
    } else {
      var remaining = 3 - partial;
      heading = completeGroups === 1 ? '¡Ya tienes un 3x2!' : '¡Ya tienes ' + completeGroups + ' ofertas 3x2!';
      detail = 'Te ' + (remaining === 1 ? 'falta 1 artículo' : 'faltan 2 artículos') + ' para otro 3x2: el de menor precio será GRATIS.';
    }

    var box = buildBanner();
    box.querySelector('.jj-promo3-heading').textContent = heading;
    box.querySelector('.jj-promo3-detail').textContent = detail;
    var progress = count > 0 && partial === 0 ? 3 : partial;
    box.querySelector('.jj-promo3-track').setAttribute('aria-valuenow', String(progress));
    box.querySelector('.jj-promo3-progress').style.width = (progress / 3 * 100).toFixed(0) + '%';
    box.hidden = false;
    document.body.classList.add('jj-promo3-visible');
  }

  function refresh() {
    if (!baseFetch) return;
    var request = ++version;
    baseFetch(basePath() + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo consultar el carrito');
        return response.json();
      })
      .then(function (cart) {
        if (request === version) render(cart);
      })
      .catch(function () {});
  }

  function eventUpdate(event) {
    if (event && event.detail && Array.isArray(event.detail.items)) {
      version++;
      render(event.detail);
    } else {
      window.setTimeout(refresh, 150);
    }
  }

  function isCartChange(url) {
    if (!url) return false;
    var path = '';
    try {
      path = new URL(String(url), window.location.href).pathname;
    } catch (_) {
      path = String(url).split('?')[0];
    }
    var segments = path.split('/').filter(Boolean);
    var action = segments.pop();
    return segments.pop() === 'cart' && ['add','add.js','change','change.js','update','update.js','clear','clear.js'].indexOf(action) !== -1;
  }

  if (baseFetch) {
    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var url = typeof request === 'string' ? request : request && request.url;
      return baseFetch.apply(window, args).then(function (response) {
        if (response && response.ok && isCartChange(url)) {
          window.setTimeout(refresh, 180);
        }
        return response;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__jjPromoCartChange = isCartChange(url);
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__jjPromoCartChange) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            window.setTimeout(refresh, 180);
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.action && isCartChange(form.action)) {
      window.setTimeout(refresh, 500);
    }
  }, true);

  ['jj:everyday-cart-updated','jj:collection-cart-updated','cart:updated','cart:refresh','cart:change','cart-drawer:updated','product:added'].forEach(function (name) {
    document.addEventListener(name, eventUpdate);
  });

  var remainingToExpiry = PROMO_DEADLINE - Date.now();
  if (remainingToExpiry > 0) window.setTimeout(hide, remainingToExpiry);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();
